import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material'
import { FC, useCallback, useState } from 'react'

import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { useCreateShopVendorMutation } from '../../../redux/api'
import { VendorEntry } from '../../../sdk'
import {
  CreateSupplierAutocomplete,
  ModifiedIdName
} from './CreateSupplierAutocomplete'

interface Props {
  handleClose: () => void
  initialSupplier?: ModifiedIdName
  setNewSupplier?: React.Dispatch<React.SetStateAction<VendorEntry | undefined>>
}

export const CreateSupplierDialog: FC<Props> = ({
  handleClose,
  initialSupplier,
  setNewSupplier
}) => {
  const { accessToken, shopId } = useAccessTokenAndShopId()

  const [supplierName, setSupplierName] = useState<ModifiedIdName | undefined>(
    initialSupplier || undefined
  )

  const [createVendor] = useCreateShopVendorMutation()

  const addVendor = useCallback(async () => {
    if (!supplierName) {
      return
    }

    const newVendorId = await createVendor({
      authorization: accessToken,
      vendorInfo: {
        shop: shopId,
        name: supplierName.inputValue || supplierName.name,
        partsTechId: supplierName.id,
        accountNumber: undefined,
        archivedOn: undefined
      }
    }).unwrap()

    // pass the newly created vendorEntry to parent
    setNewSupplier &&
      setNewSupplier({
        id: newVendorId.replace(/["\\]/g, ''), // need to remove extra quotation marks
        info: {
          shop: shopId,
          name: supplierName.inputValue || supplierName.name || '',
          partsTechId: supplierName.id || undefined,
          accountNumber: undefined,
          archivedOn: undefined
        }
      })

    handleClose()
  }, [
    accessToken,
    createVendor,
    handleClose,
    setNewSupplier,
    shopId,
    supplierName
  ])

  return (
    <Dialog open={true} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Vendor</DialogTitle>
      <DialogContent>
        <Box pt={2}>
          <CreateSupplierAutocomplete
            {...{
              supplier: supplierName,
              setSupplier: setSupplierName,
              initialSupplier: undefined // new form so no past information
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ spacing: 2 }}>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="contained" onClick={addVendor}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  )
}
